module.exports = __webpack_public_path__ + "static/stone-giant-raid-1a9a4a74a7eae3e2725e125a49aa25a0.jpg";